import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { Automation } from '../../builder.types';
import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export abstract class FormBase<T> extends OnDestroyMixin {
  @Input() automation: Automation;
  @Output() cancel = new EventEmitter();
  @Output() ok = new EventEmitter<T>();

  constructor() {
    super();
  }
}
